import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { IStrapiResponse, StrapiQueryParams } from '@/Models';
import { logApiCall, getTraceId } from '@/Services';

const strapiBaseUrl = import.meta.env.VITE_STRAPI_BASE_URL;
const strapiWithdrawalPath = import.meta.env.VITE_STRAPI_WITHDRAWAL_PATH;
const strapiPlatform = import.meta.env.VITE_STRAPI_PLATFORM;

export const strapiApi = createApi({
  reducerPath: 'strapiApi',
  baseQuery: fetchBaseQuery({
    baseUrl: strapiBaseUrl,
    prepareHeaders: (headers) => {
      const traceId = getTraceId();
      if (traceId) {
        headers.set('x-trace-id', traceId);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['StrapiData'],
  endpoints: (builder) => ({
    getStrapiWithdrawalData: builder.query<IStrapiResponse, StrapiQueryParams | void>({
      query: (params) => {
        const path = params?.path || strapiWithdrawalPath;
        const platform = params?.platform || strapiPlatform;
        
        return {
          url: '',
          method: 'GET',
          params: {
            Path: path,
            Platform: platform,
          },
        };
      },
      providesTags: ['StrapiData'],
      async onQueryStarted(_arg, { queryFulfilled }) {
        const startTime = Date.now();
        try {
          await queryFulfilled;
          logApiCall('GET', `${strapiBaseUrl}`, 200, Date.now() - startTime);
        } catch (error: unknown) {
          const apiError = error as { error?: { status?: number } };
          logApiCall('GET', `${strapiBaseUrl}`, apiError?.error?.status, Date.now() - startTime, error instanceof Error ? error : new Error(String(error)));
        }
      },
    }),
  }),
});

export const {
  useGetStrapiWithdrawalDataQuery,
  useLazyGetStrapiWithdrawalDataQuery,
} = strapiApi;
